import { Link } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { Blog } from '../../interfaces/Blog/Blog';
import { sharedColors } from '../../utils/Style';
import { useThemeColor } from '../../hooks/useThemeColor';

type BlogPreviewProps = {
  blog: Blog;
};

export const BlogPreview = ({ blog }: BlogPreviewProps) => {
  const { primary } = useThemeColor();

  return (
    <Link to={`/blog/${blog.slug}`} style={{ textDecoration: 'none' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            paddingBottom: '75%',
            overflow: 'hidden',
          }}
        >
          <Box
            component='img'
            src={blog.coverImage}
            alt={blog.title}
            width='100%'
            height='auto'
            display='block'
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          />
        </Box>

        <Button
          sx={{
            color: sharedColors.black,
            textTransform: 'none',
            transition: 'color 0.5s ease',
            fontSize: '18px',
            fontWeight: 600,
            mt: 1,
            p: 0,
            '&:hover': {
              color: primary,
              backgroundColor: 'transparent',
            },
          }}
        >
          {blog.title}
        </Button>

        <Typography sx={{ color: sharedColors.black }}>
          {blog.shortDescription}
        </Typography>
      </Box>
    </Link>
  );
};
